export { RegisterModal } from './RegisterModal.component';
